module.exports = __webpack_public_path__ + "static/media/mockup5.1435e033.png";